import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { DataService } from '../../services/data.service';
import * as AEMActions from '../actions/educational-content.actions';

@Injectable()
export class EducationalContentEffects {
  loadAEMEducationalContent$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AEMActions.loadAEMContent),
      switchMap(() =>
        this.data.getEducationalContent().pipe(
          map((content) =>
            AEMActions.loadAEMContentSuccess({
              aemContent: {
                id: 'aem-educational-content',
                aemContent: content
              }
            })
          ),
          catchError(() =>
            of(
              AEMActions.loadAEMContentFailure({
                aemContentError: {
                  id: 'aem-educational-content-error',
                  aemContentError: 'educational-content'
                }
              })
            )
          )
        )
      )
    )
  );

  constructor(
    private readonly actions$: Actions,
    private readonly data: DataService
  ) {}
}
